var HelpPageMsg = 'This is Help page. Here you can find information on how to navigate in the application. Use tab to go to the next field.';
var speakValue = "";
var inputValue = "";
var inputplaceholder = "";
var typingTimer;                //timer identifier
var doneTypingInterval = 1800;  //time in ms
var tabKeyCode = 9;
var enterKeyCode = 13;
var DisplayUserInput = "";
var speakValueOnKeyPress = "";

function HelpPageLoad() {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    responsiveVoice.speak(HelpPageMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
  }
  HelpCaption(HelpPageMsg, tabKeyCode);
}

/*------------------------------------------------------------------
      Common Function for Caption.
------------------------------------------------------------------*/
function HelpCaption(newCaptionInput, keyCode) {
  //debugger;
  if (keyCode == tabKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
  if (keyCode == enterKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }



}

/*------------------------------------------------------------------
      Common Function for speak which is connected with registration component.ts file.
------------------------------------------------------------------*/
function HelpresponsiveVoiceSpeak(inputplaceholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key) {
  debugger;
  if (eventId == "SkipMainContentfooter") {
    responsiveVoice.cancel();
    HelpCaption(innerText, tabKeyCode);
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Skip the Footer. Use this link to skip the footer.On selection, it shall take you to the Skip to main content link.Use the Enter key to select or use tab to go to the footer.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Use this link to skip the footer.On selection, it shall take you to the Skip to main content link.Use the Enter key to select or use tab to go to the footer.", tabKeyCode);
    return;
  }

  if (controlType == "text") {
      if (inputValue == "") {
        HelpspeakForAnchorTagControlType(inputValue, inputplaceholder, keyCode);
      }
    }
    if (controlType == "textarea") {      
      HelpspeakForAnchorTagControlType(inputValue, keyCode);
    }
    if ( 
      eventId == "trexit" 
      
     ) {
      HelpspeakForAnchorTagControlType(innerText, title, keyCode);      
  }

  //if (eventId == "nvdaheading"||eventId == "nvdaheading") {
  //  scrollup();
  //}

  if (eventId == "lblhelp") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Help. The following table consist the commands for various functions on this site. Use tab to traverse through the table or at any time, use Escape key to exit the table and go to the footer. Use tab to go the table.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Help. The following table consist the commands for various functions on this site. Use tab to traverse through the table or at any time, use Escape key to exit the table and go to the footer. Use tab to go the table.", keyCode);
    return;
  }


  if (eventId == "trNext") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To move to the next field. Use Tab. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To move to the next field. Use Tab. Use tab to go to the next field. ", keyCode);
      return;
    }

  if (eventId == "trprevious") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To move to previous field. Use Shift+Tab. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To move to previous field. Use Shift+Tab. Use tab to go to the next field. ", keyCode);
    return;
  }

  if (eventId == "trLink") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To click on a Link. Use Enter. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To click on a Link.Use Enter. Use tab to go to the next field. ", keyCode);
    return;
  }


  if (eventId == "trbutton") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To click on a button. Use Enter. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To click on a button. Use Enter. Use tab to go to the next field. ", keyCode);
    return;
  }

  if (eventId == "truncheck") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To check or uncheck a Checkbox. Use Spacebar. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To check or uncheck a Checkbox. Use Spacebar. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "trexpand") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To expand a Menu. Use Enter. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To expand a Menu. Use Enter. Use tab to go to the next field. ", keyCode);
    return;
  }

  if (eventId == "trDown") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To traverse through the rows of a list or table. Use UP and Down Arrow keys. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To traverse through the rows of a list or table. Use UP and Down Arrow keys. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "trside") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To traverse through the items of a horizontal list. Use Side-by-side Arrow keys. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To traverse through the items of a horizontal list. Use Side-by-side Arrow keys. Use tab to go to the next field. ", keyCode);
    return;
  }
  
  if (eventId == "troption") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To select an option, a row or an item. Use Enter. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To select an option, a row or an item. Use Enter. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "trexit") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("To exit from a list or go back to main menu at any point. Use Escape. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("To exit from a list or go back to main menu at any point. Use Escape. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "nvdaheading") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("We are using NVDA for PDF reader. Following are the commands for reading PDF documents. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("We are using NVDA for PDF reader. Following are the commands for reading PDF documents. Use tab to go to the next field. ", keyCode);
    return;
  }

  if (eventId == "tblFunction1") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Function. NVDA command. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Function. NVDA command. Use tab to go to the next field. ", keyCode);
    return;
  }

  if (eventId == "tblFunction2") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Read Document Title. Insert + T. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Read Document Title. Insert + T. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction3") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Read Next Line. Down Arrow. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Read Next Line. Down Arrow. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction4") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Read Previous Line. Up Arrow. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Read Previous Line. Up Arrow. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction5") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Read Next Paragraph. P. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Read Next Paragraph. P. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction6") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Read Previous Paragraph. Shift + P. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Read Previous Paragraph. Shift + P. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction7") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Read continuously (Say All). Insert + Down Arrow. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Read continuously (Say All). Insert + Down Arrow. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction8") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to a page. Ctrl + Shift + N. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to a page. Ctrl + Shift + N. Use tab to go to the next field.", keyCode);
    return;
  }

  if (eventId == "tblFunction9") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next page. Ctrl + Page Down. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next page. Ctrl + Page Down. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction10") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous page. Ctrl + Page Up. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous page. Ctrl + Page Up. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction11") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Open the Find dialog. Ctrl + Insert + F. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Open the Find dialog. Ctrl + Insert + F. Use tab to go to the next field.", keyCode);
    return;
  }

  if (eventId == "tblFunction12") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Open the Links list dialog (JAWS) or Elements List dialog (NVDA). Insert + F7. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Open the Links list dialog (JAWS) or Elements List dialog (NVDA). Insert + F7. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction13") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Link. Tab or K. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Link. Tab or K. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction14") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Link. Shift + Tab or Shift + K. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Link. Shift + Tab or Shift + K. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction15") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Open the Headings list dialog (JAWS) or Elements List dialog (NVDA). Insert + F7 then Alt + H. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Open the Headings list dialog (JAWS) or Elements List dialog (NVDA). Insert + F7 then Alt + H. Use tab to go to the next field. ", keyCode);
    return;
  }

  if (eventId == "tblFunction16") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Heading. H. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Heading. H. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction17") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Heading. Shift + H. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Heading. Shift + H. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction18") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Table. T. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Table. T. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction19") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Table. H. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Table. H. Use tab to go to the next field.", keyCode);
    return;
  }
  //if (eventId == "tblFunction20") {
  //  responsiveVoice.cancel();
  //  responsiveVoice.speak("Read current cell in a Table. -. Use tab to go to the next field. ");
  //  HelpCaption("Read current cell in a Table. -. Use tab to go to the next field.", keyCode);
  //  return;
  //}
  if (eventId == "tblFunction21") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next cell in a Table. Ctrl + Alt + Right Arrow. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next cell in a Table. Ctrl + Alt + Right Arrow. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction22") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous cell in a Table. Ctrl + Alt + Left Arrow. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous cell in a Table. Ctrl + Alt + Left Arrow. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction23") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Graphic. G. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Graphic. G. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction24") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Graphic. Shift + G. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Graphic. Shift + G. Use tab to go to the next field.", keyCode);
    return;
  }
  //if (eventId == "tblFunction25") {
  //  responsiveVoice.cancel();
  //  responsiveVoice.speak("Open the Select a Graphic dialog. -. Use tab to go to the next field. ");
  //  HelpCaption("Open the Select a Graphic dialog. -. Use tab to go to the next field.", keyCode);
  //  return;
  //}
  if (eventId == "tblFunction26") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next List. L. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next List. L. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction27") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous List. Shift + L. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous List. Shift + L. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction28") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next List Item. I. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next List Item. I. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction29") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous List Item. Shift + I. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous List Item. Shift + I. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction30") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Close the pdf. Ctrl+F4. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Close the pdf. Ctrl+F4. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction31") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Following are the commands for reading PDF forms. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Following are the commands for reading PDF forms. Use tab to go to the next field.", keyCode);
    return;
  }
  //if (eventId == "tblFunction32") {
  //  responsiveVoice.cancel();
  //  responsiveVoice.speak("Function.NVDA command. Use tab to go to the next field. ");
  //  HelpCaption("Function.NVDA command. Use tab to go to the next field.", keyCode);
  //  return;
  //}
  //if (eventId == "tblFunction33") {
  //  responsiveVoice.cancel();
  //  responsiveVoice.speak("Open the Forms list dialog. -. Use tab to go to the next field. ");
  //  HelpCaption("Open the Forms list dialog. -. Use tab to go to the next field.", keyCode);
  //  return;
  //}
  if (eventId == "tblFunction34") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Turn off Forms Mode (JAWS) or Focus Mode (NVDA). Insert + Spacebar. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Turn off Forms Mode (JAWS) or Focus Mode (NVDA). Insert + Spacebar. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction35") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Button. B. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Button. B. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction36") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Button. Shift + B. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Button. Shift + B. Use tab to go to the next field. ", keyCode);
    return;
  }
  if (eventId == "tblFunction37") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Combo box. C. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Combo box. C. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction38") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Combo box. Shift + C. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Combo box. Shift + C. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction39") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Edit field. E. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Edit field. E. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction40") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Edit field. Shift + E. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Edit field. Shift + E. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction41") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Form field. F. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Form field. F. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction42") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Table. Shift + R. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Table. Shift + R. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction43") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Next Checkbox. X. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Next Checkbox. X. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction44") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Go to Previous Checkbox. Shift + X. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Go to Previous Checkbox. Shift + X. Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction45") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Play or Pause the audio. Control + spacebar. Use tab to go to the next field. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Play or Pause the audio. CTRL + spacebar.Use tab to go to the next field.", keyCode);
    return;
  }
  if (eventId == "tblFunction46") {
    responsiveVoice.cancel();
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak("Close the pdf. alt + f4. This is the end of the help page. Use tab to go to the footer. ", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HelpCaption("Close the pdf. ALT + F4. This is the end of the help page. Use tab to go to the footer.", keyCode);
    return;
  }
}

//function scrollup() {
//  debugger; 
//  $("html, body").animate({
//    scrollTop: $(
//      'html, body').get(0).scrollHeight
//  }, 1000);
//}


/*------------------------------------------------------------------
      Common Function for anchor controls.
------------------------------------------------------------------*/
function HelpspeakForAnchorTagControlType(innerText, title, keyCode) {
  debugger;
  if ($('#hidVoiceOnOff').val() == 'ON') {
    responsiveVoice.cancel();

    if (innerText == 'A-') {
      if ($('#hidVoiceOnOff').val() == 'ON') {
        responsiveVoice.speak("A. Minus", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
      }
    }
    else {
      if ($('#hidVoiceOnOff').val() == 'ON') {
        responsiveVoice.speak(innerText + ' ' + "Use tab to go to the next field.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
      }
    }
  }
  HelpCaption(innerText, keyCode);
  //responsiveVoice.speak(title);
  HelpCaption("Use tab to go to the next field.", keyCode);
}
